module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Communication/Address-card-7511fea890ea89a530dd2e9b137bfc8d.svg";